import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dropzone/styles.css';

import { App } from './App.tsx';
import { onUnauthorized } from './api/client.ts';
import { useAuthStore } from './auth/store.ts';
import { ErrorBoundary } from './layout/ErrorBoundary.tsx';
import './i18n/index.ts';

const theme = createTheme({
  primaryColor: 'indigo',
  fontFamily:
    'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  defaultRadius: 'md',
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Open the login modal on any 401 we see from the API client. Single hook
// installed at module load — uninstalled if the bundle is ever hot-reloaded.
onUnauthorized(() => {
  const s = useAuthStore.getState();
  s.setUser(null);
  s.openLoginModal();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <MantineProvider theme={theme} defaultColorScheme="light">
        <QueryClientProvider client={queryClient}>
          <ModalsProvider>
            <Notifications position="top-right" />
            <App />
          </ModalsProvider>
        </QueryClientProvider>
      </MantineProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
